import { Component, OnInit, Input, Optional, HostBinding } from "@angular/core";
import { CardComponent } from "../card/card.component";

@Component({
  selector: "av-control-section",
  templateUrl: "./control-section.component.html",
  styleUrls: ["./control-section.component.scss"],
})
export class ControlSectionComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;

  constructor(@Optional() private card: CardComponent) {}

  @HostBinding("class") get class() {
    return {
      "control-section-card": !!this.card,
    };
  }

  ngOnInit(): void {}
}
